import { Delta } from "@vueup/vue-quill";

export const useClipboardSpanMatcher = () => {
  return (node: any, delta: any) => {
    const styleObject = useConvertElementStyles(node);
    const className = node.getAttribute("class");

    if (className && className.includes("tab-span")) {
      // Return an op with the firstline-indent embed
      const width = node.getAttribute("data-width") || "1em";
      return new Delta([
        {
          insert: {
            "firstline-indent": { width },
          },
        },
      ]);
    }

    if (!delta.ops || delta.ops.length === 0) {
      return delta;
    }

    const textDecoration =
      styleObject["text-decoration"] || styleObject["textDecoration"];
    const textDecorationLine = styleObject["text-decoration-line"];
    const decorationValue = [textDecoration, textDecorationLine]
      .filter(Boolean)
      .join(" ");

    const backgroundColor =
      styleObject["background-color"] || styleObject["backgroundColor"];

    const nextOps = delta.ops.map((op: any) => {
      if (typeof op?.insert !== "string") {
        return op;
      }

      const nextAttributes = {
        ...(op.attributes ?? {}),
      } as Record<string, any>;

      if (decorationValue.includes("underline")) {
        nextAttributes["underline"] = true;
      }

      if (decorationValue.includes("line-through")) {
        nextAttributes["strike"] = true;
      }

      if (backgroundColor) {
        nextAttributes["background"] = backgroundColor;
      }

      if (Object.keys(nextAttributes).length === 0) {
        return op;
      }

      return {
        ...op,
        attributes: nextAttributes,
      };
    });

    return new Delta(nextOps);
  };
};
